import React from "react";
import {
  Box,
  Typography,
  Stack,
  Tooltip,
  IconButton,
  Divider,
} from "@mui/material";
import { StyledCard } from "../common/StyledCard";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { BrandResponseDto } from "../../shared/dtos/brand/BrandResponseDto";

interface BrandCardProps {
  brand: BrandResponseDto;
  onEdit?: () => void;
  onDelete?: () => void;
}

const BrandCard: React.FC<BrandCardProps> = ({ brand, onEdit, onDelete }) => {
  return (
    <StyledCard>
      <Box
        sx={{
          p: 2,
          display: "flex",
          flexDirection: "column",
          height: "100%",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: 120,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mb: 2,
            bgcolor: "#fff",
            borderRadius: 1,
            p: 1,
          }}
        >
          {brand.logoUrl ? (
            <img
              src={brand.logoUrl}
              alt={brand.name}
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
              }}
              onError={(e) => {
                (e.target as HTMLImageElement).src =
                  "https://placehold.co/300x300?text=No+Image";
              }}
            />
          ) : (
            <Typography
              variant="h4"
              sx={{ color: "primary.light", fontWeight: "bold" }}
            >
              {brand.name.charAt(0)}
            </Typography>
          )}
        </Box>

        <Typography
          variant="h6"
          noWrap
          sx={{ width: "100%", fontWeight: "bold" }}
        >
          {brand.name}
        </Typography>

        <Divider sx={{ my: 1.5, width: "100%" }} />

        <Stack direction="row" spacing={1}>
          {onEdit && (
            <Tooltip title="Edit Brand">
              <IconButton size="small" onClick={onEdit}>
                <EditOutlinedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
          {onDelete && (
            <Tooltip title="Delete Brand">
              <IconButton size="small" color="error" onClick={onDelete}>
                <DeleteOutlineIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </Stack>
      </Box>
    </StyledCard>
  );
};

export default BrandCard;
